import { IMultiOptionsColors } from "@mctypes/global.types";
import React, { useEffect, useState } from "react";
import { Flex } from "@mantine/core";


const OptionBadge: React.FC<{
  options: IMultiOptionsColors[];
  activeOption: string;
  noWrap?: boolean;
}> = ({ options, activeOption, noWrap = false }) => {
  const [option, setOption] = useState<IMultiOptionsColors | null>({
    key: "NONE",
    displayName: "-",
    color: "white",
  });

  useEffect(() => {
    const opt = options?.find((_option) => _option.key === activeOption);

    if (opt != null) {
      setOption(opt);
    }
  }, [activeOption]);

  return (
    <Flex style={{ alignItems: "center" }}>
      <div className="statusdot" style={{ backgroundColor: option.color }}></div>
      <div style={{ color: "#58595B", fontSize: "12px", whiteSpace: noWrap === true ? "nowrap" : "normal" }}>
        {option.displayName.toUpperCase()}
      </div>
    </Flex>
  );
};

export default OptionBadge;
